import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var ToiletPaperSlash = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 640 512"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M64 192v172.13c0 41.12-9.75 62.75-31.12 126.87A16 16 0 0 0 48 512h280.86a31.87 31.87 0 0 0 30.38-21.87c9.31-27.83 18-53.35 22.18-85.55l-316-244.25C64.53 170.66 64 181.19 64 192zm569.82 266.09-102-78.81C575.28 360.91 608 284.32 608 192 608 86 565 0 512 0s-96 86-96 192c0 42 7 80.4 18.43 112L384 265v-73c0-83.62 23.63-153.5 60.5-192H160c-23.33 0-44.63 16.83-61.26 44.53L45.46 3.38A16 16 0 0 0 23 6.19L3.37 31.45a16 16 0 0 0 2.81 22.46l588.36 454.72a16 16 0 0 0 22.46-2.82l19.64-25.26a16 16 0 0 0-2.82-22.46zM512 256c-17.63 0-32-28.62-32-64s14.37-64 32-64 32 28.63 32 64-14.38 64-32 64z"
  }));
});
ToiletPaperSlash.displayName = 'ToiletPaperSlash';
export var ToiletPaperSlashDimensions = {
  height: 512,
  width: 640
};